import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000, // 请求超时时间
  // 默认设置JSON请求头
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器 - 自动添加认证令牌
service.interceptors.request.use(
  config => {
    // 从localStorage获取令牌
    const token = localStorage.getItem('token');
    // 如果令牌存在，添加到请求头
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 处理401未授权和403权限不足错误
    if (error.response) {
      const { status } = error.response;
      
      // token过期或未登录(401)、权限不足(403)
      if (status === 401 || status === 403) {
        // 清除无效token
        localStorage.removeItem('token');
        
        // 显示错误提示
        const message = status === 401 
          ? '登录已过期，请重新登录' 
          : '没有访问权限，请联系管理员';
        Message.error(message);
        
        // 跳转到登录页，并记录当前路径以便登录后返回
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        });
      } else {
        // 其他错误
        const errorMsg = error.response.data?.message || '操作失败，请重试';
        Message.error(errorMsg);
      }
    } else {
      // 网络错误
      Message.error('网络连接失败，请检查网络设置');
    }
    
    return Promise.reject(error);
  }
);

export default service;